/* PDP conversion upgrade: mobile sticky add-to-cart bar controller (see snippets/pdp-sticky-atc.liquid) */
(function () {
  function initPdpStickyAtc(bar) {
    var sectionId = bar.dataset.sectionId;
    var anchorId = bar.dataset.anchorId;
    var priceSourceId = bar.dataset.priceSourceId;
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    var priceSource = priceSourceId ? document.getElementById(priceSourceId) : null;
    var priceTarget = bar.querySelector('[data-pdp-sticky-price]');
    var submitButton = bar.querySelector('[data-pdp-sticky-submit]');

    /* Keep the accessibility tree in sync with the visual state: while the
       bar is off-screen it must be aria-hidden AND unfocusable, otherwise
       screen-reader/keyboard users hit a focusable-but-invisible button. */
    function setBarVisible(visible) {
      bar.classList.toggle('pdp-sticky-atc--visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      if (submitButton) submitButton.tabIndex = visible ? 0 : -1;
    }

    function syncPrice() {
      if (!priceSource || !priceTarget) return;
      var priceItem =
        priceSource.querySelector('.price-item--last') ||
        priceSource.querySelector('.price-item--regular') ||
        priceSource.querySelector('.price-item');
      var text = (priceItem || priceSource).textContent.replace(/\s+/g, ' ').trim();
      if (text) priceTarget.textContent = text;
    }

    function syncAvailability() {
      var realButton = anchorId ? document.getElementById(anchorId) : null;
      if (!realButton || !submitButton) return;
      var disabled = realButton.hasAttribute('disabled');
      submitButton.disabled = disabled;
      bar.classList.toggle('pdp-sticky-atc--unavailable', disabled);
    }

    setBarVisible(false);
    syncPrice();
    syncAvailability();

    if (priceSource && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    var productInfo = sectionId ? document.getElementById('ProductInfo-' + sectionId) : null;
    if (productInfo && 'MutationObserver' in window) {
      new MutationObserver(syncAvailability).observe(productInfo, {
        attributes: true,
        subtree: true,
        attributeFilter: ['disabled']
      });
    }

    if (anchor && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setBarVisible(!entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(anchor);
    }
  }

  function init() {
    var bars = document.querySelectorAll('[data-pdp-sticky-atc]');
    bars.forEach(initPdpStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
